/* eslint-disable */
const methods = {
  sopheo: {
    Paths: {
      login: "token",
      anclarIncidencia: "Incidencias/Anclar",
      cliente: "Cliente",
      instalacion: "Instalacion",
      instalacionEquipo: "InstalacionEquipo",
      personaContacto: "InstalacionPersonaContacto",
      programa: "Programa",
      prioridad: "Prioridad",
      incidencia: "Incidencias",
      incidenciaEstado: "IncidenciaEstado",
      tecnico: "Tecnico",
      tipoIncidencia: "TipoIncidencia",
      trabajosRealizados: "TrabajosRealizados",
      traspasarIncidencia: "Incidencias/Traspasar",
      seguirIncidencia: "Incidencias/Seguir",
      recuentoTecnicoEstado: "Estadisticas/tecnicoEstado",
      recuentoTecnicoTiempo: "Estadisticas/tecnicoTiempo",
      file: "Archivos",
      clientes: "ClientesAsync",
      getPersonaContacto: "InstalacionPersonaContacto/getPersonaContacto",
      areaTrabajo: "AreaTrabajo",
      departamentos: "Departamentos",
      sistemaOperativo: "SistemaOperativo",
      usuarios: "Usuario",
      operario: "Operario",
      postPersonaContacto: "InstalacionPersonaContacto/postPersonaContacto",
      usuariosacces: "UsuariosAcces",
      instalacionEspecifica: "Instalacion/espeInstalacion",
      uploadTrelloFile: "Trello/attachFile",
      enviarEmailContacto: "Incidencias/EnviarEmailContacto"
    }
  }
};

export default methods;
